import React, { useEffect } from 'react';

import { Banana, Cabbage, Earth, Mango } from '../../ui-library/typography';
import { Space } from '../../ui-library/space';
import StyledContainer from '../../ui-library/styled/StyledContainer';
import useScroll from '../../utils/useScroll';
import useTitle from '../../utils/useTitle';

const TermsOfServicePage = () => {
  const { scrollToId } = useScroll();

  useTitle();

  useEffect(() => {
    setTimeout(() => {
      scrollToId('terms-of-service');
    }, 100);
  }, []);

  return (
    <StyledContainer id='terms-of-service'>
      <Space size={16} />
      <Cabbage>Terms of Service</Cabbage>
      <Earth>
        <b>Effective Date:</b> October 15, 2021
      </Earth>
      <Earth marginBottom='16px'>
        <b>Last Modified Date:</b> October 15, 2021
      </Earth>
      <Earth marginBottom='16px'>
        These terms of service (“Terms”) cover your use and access to our
        services, client software and websites ("Services").
      </Earth>
      <Mango>Minimum Age</Mango>
      <Earth marginBottom='16px'>
        You must be at least 16 years old to use our Services. The minimum age
        to use our Services without parental approval may be higher in your home
        country.
      </Earth>
      <Mango>Account Registration</Mango>
      <Earth marginBottom='16px'>
        To create an account you must register for our Services using your real
        name and email. To receive products purchased using our Services you
        must register with your phone number and physical address. You agree to
        receive text messages and phone calls (from us or our third-party
        providers) in order to provide you our Services.
      </Earth>
      <Mango>Privacy of User Data</Mango>
      <Earth marginBottom='16px'>
        All data that we collect in order to provide you our Services shall be
        governed in accordance with our Privacy Policy.
      </Earth>
      <Earth marginBottom='64px'>
        Please read our Privacy Policy to understand how we safeguard the
        information you provide when using our Services. For the purpose of
        operating our Services, you agree to our data practices as described in
        our Privacy Policy, as well as the transfer of your encrypted
        information and metadata to the United States and other countries where
        we have or use facilities, service providers or partners. Examples would
        be Third Party Providers sending you a verification code and processing
        your support tickets.
      </Earth>

      <Banana marginBottom='16px'>Using AskOkey</Banana>
      <Mango>Our Terms and Policies</Mango>
      <Earth marginBottom='16px'>
        You must use our Services according to our Terms and posted policies. If
        we disable your account for a violation of our Terms, you will not
        create another account without our permission.
      </Earth>
      <Mango>Legal and Acceptable Use</Mango>
      <Earth marginBottom='16px'>
        You agree to use our Services only for legal, authorized, and acceptable
        purposes. You will not use (or assist others in using) our Services in
        ways that violate or infringe the rights of AskOkey, our users, or
        others, including privacy, publicity, intellectual property, or other
        proprietary rights.
      </Earth>
      <Mango>Harm to AskOkey</Mango>
      <Earth marginBottom='16px'>
        You must not (or assist others to) access, use, modify, distribute,
        transfer, or exploit our Services in unauthorized manners, or in ways
        that harm AskOkey, our Services, or systems. For example you must not
        (a) gain or try to gain unauthorized access to our Services or systems;
        (b) disrupt the integrity or performance of our Services; (c) create
        accounts for our Services through unauthorized or automated means; (d)
        collect information about our users in any unauthorized manner; or (e)
        sell, rent, or charge for our Services.
      </Earth>
      <Mango>Keeping Your Account Secure</Mango>
      <Earth marginBottom='16px'>
        You are responsible for keeping your device and your AskOkey account
        safe and secure.
      </Earth>
      <Mango>Third Party Services</Mango>
      <Earth marginBottom='64px'>
        Our Services may allow you to access, use, or interact with third party
        websites, apps, content, and other products and services. When you use
        third party services, their terms and privacy policies govern your use
        of those services. For example, we use external services for processing
        your payments and physically delivering your orders. All access to these
        services are governed by our third-party providers, in addition to the
        Terms defined here.
      </Earth>

      <Banana marginBottom='16px'>Your Rights and License with AskOkey</Banana>
      <Mango>Your Rights</Mango>
      <Earth marginBottom='16px'>
        You own the information you submit through our Services. You must have
        the rights to the email address you use to sign up for your AskOkey
        account.
      </Earth>
      <Mango>AskOkey’s Rights</Mango>
      <Earth marginBottom='16px'>
        We own all copyrights, trademarks, domains, logos, trade dress, trade
        secrets, patents, and other intellectual property rights associated with
        our Services. You may not use our copyrights, trademarks, domains,
        logos, trade dress, patents, and other intellectual property rights
        unless you have our written permission.
      </Earth>
      <Mango>AskOkey’s License to You</Mango>
      <Earth marginBottom='64px'>
        AskOkey grants you a limited, revocable, non-exclusive, and
        non-transferable license to use our Services in accordance with these
        Terms.
      </Earth>

      <Banana marginBottom='16px'>Disclaimers and Limitations</Banana>
      <Mango>Disclaimers</Mango>
      <Earth marginBottom='16px'>
        YOU USE OUR SERVICES AT YOUR OWN RISK AND SUBJECT TO THE FOLLOWING
        DISCLAIMERS. WE PROVIDE OUR SERVICES ON AN “AS IS” BASIS WITHOUT ANY
        EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
        NON-INFRINGEMENT, AND FREEDOM FROM COMPUTER VIRUS OR OTHER HARMFUL CODE.
        ASKOKEY DOES NOT WARRANT THAT ANY INFORMATION PROVIDED BY US IS
        ACCURATE, COMPLETE, OR USEFUL, THAT OUR SERVICES WILL BE OPERATIONAL,
        ERROR-FREE, SECURE, OR SAFE, OR THAT OUR SERVICES WILL FUNCTION WITHOUT
        DISRUPTIONS, DELAYS, OR IMPERFECTIONS. WE DO NOT CONTROL, AND ARE NOT
        RESPONSIBLE FOR, CONTROLLING HOW OR WHEN OUR USERS USE OUR SERVICES. WE
        ARE NOT RESPONSIBLE FOR THE ACTIONS OR INFORMATION (INCLUDING CONTENT)
        OF OUR USERS OR OTHER THIRD PARTIES. YOU RELEASE US, AFFILIATES,
        DIRECTORS, OFFICERS, EMPLOYEES, PARTNERS, AND AGENTS (TOGETHER, “ASKOKEY
        PARTIES”) FROM ANY CLAIM, COMPLAINT, CAUSE OF ACTION, CONTROVERSY, OR
        DISPUTE (TOGETHER, “CLAIM”) AND DAMAGES, KNOWN AND UNKNOWN, RELATING TO,
        ARISING OUT OF, OR IN ANY WAY CONNECTED WITH ANY SUCH CLAIM YOU HAVE
        AGAINST ANY THIRD PARTIES.
      </Earth>
      <Mango>Limitation of Liability</Mango>
      <Earth marginBottom='16px'>
        THE ASKOKEY PARTIES WILL NOT BE LIABLE TO YOU FOR ANY LOST PROFITS OR
        CONSEQUENTIAL, SPECIAL, PUNITIVE, INDIRECT, OR INCIDENTAL DAMAGES
        RELATING TO, ARISING OUT OF, OR IN ANY WAY IN CONNECTION WITH OUR TERMS,
        US, OR OUR SERVICES, EVEN IF THE ASKOKEY PARTIES HAVE BEEN ADVISED OF
        THE POSSIBILITY OF SUCH DAMAGES. OUR AGGREGATE LIABILITY RELATING TO,
        ARISING OUT OF, OR IN ANY WAY IN CONNECTION WITH OUR TERMS, US, OR OUR
        SERVICES WILL NOT EXCEED ONE HUNDRED DOLLARS ($100). THE FOREGOING
        DISCLAIMER OF CERTAIN DAMAGES AND LIMITATION OF LIABILITY WILL APPLY TO
        THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW. THE LAWS OF SOME STATES
        OR JURISDICTIONS MAY NOT ALLOW THE EXCLUSION OR LIMITATION OF CERTAIN
        DAMAGES, SO SOME OR ALL OF THE EXCLUSIONS AND LIMITATIONS SET FORTH
        ABOVE MAY NOT APPLY TO YOU. NOTWITHSTANDING ANYTHING TO THE CONTRARY IN
        OUR TERMS, IN SUCH CASES, THE LIABILITY OF THE ASKOKEY PARTIES WILL BE
        LIMITED TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.
      </Earth>
      <Mango>Availability of Our Services</Mango>
      <Earth marginBottom='64px'>
        Our Services may be interrupted, including for maintenance, upgrades, or
        network or equipment failures. We may discontinue some or all of our
        Services, including certain features and the support for certain devices
        and platforms, at any time.
      </Earth>

      <Banana marginBottom='16px'>Resolving Disputes and Ending Terms</Banana>
      <Mango>Resolving Disputes</Mango>
      <Earth marginBottom='16px'>
        You agree to resolve any Claim you have with us relating to or arising
        out of our Terms, us, or our Services exclusively in the Federal and
        state courts located in New York, New York (and of the appropriate
        appellate courts therefrom). You also agree to submit to the personal
        jurisdiction of such courts for the purpose of litigating all such
        disputes.
      </Earth>
      <Mango>Ending these Terms</Mango>
      <Earth marginBottom='16px'>
        ou may stop using our Services at any time. We reserve the right to
        modify, suspend, or terminate your access to or use of our Services
        anytime for any reason, such as if you violate the letter or spirit of
        our Terms or create harm, risk, or possible legal exposure for AskOkey.
      </Earth>
      <Earth marginBottom='16px'>
        AskOkey may update the Terms from time to time. When we update our
        Terms, we will update the “Last Modified” date associated with the
        updated Terms. Your continued use of our Services confirms your
        acceptance of our updated Terms and supersedes any prior Terms. You will
        comply with all applicable export control and trade sanctions laws. Our
        Terms cover the entire agreement between you and AskOkey regarding our
        Services. If you do not agree with our Terms, you should stop using our
        Services.
      </Earth>
      <Earth marginBottom='16px'>
        If we fail to enforce any of our Terms, that does not mean we waive the
        right to enforce them. If any provision of the Terms is deemed unlawful,
        void, or unenforceable, that provision shall be deemed severable from
        our Terms and shall not affect the enforceability of the remaining
        provisions. Our Services are not intended for distribution to or use in
        any country where such distribution or use would violate local law or
        would subject us to any regulations in another country. We reserve the
        right to limit our Services in any country.
      </Earth>
    </StyledContainer>
  );
};

export default TermsOfServicePage;
